var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { useIVASetChatStatus } from 'iva-react-web-ui';
import { Trans } from 'react-i18next';
import { ConfigContext } from '../../../context';
import { translate } from '../../../strings/i18n';
import { FAS_CIRCLE_EXCLAMATION } from '../../../../../const/icon-props';
import { OnlineChatButton } from './subcomponents';
import StatusMessage from '../StatusMessageBox';
var MaximumMessageBox = function () {
    var pointOfNeedChat = useIVASetChatStatus().pointOfNeedChat;
    var selectedAccountId = useContext(ConfigContext).selectedAccountId;
    var onlineChatText = translate('maximumMessageBox.onlineChat');
    var handleIVAChat = function () {
        pointOfNeedChat('MC', selectedAccountId);
    };
    var onlineChatLink = (_jsx(OnlineChatButton, __assign({ buttonType: "text", "data-type": "online chat", "data-analytics": "clicktrackingevent", onClick: handleIVAChat }, { children: onlineChatText })));
    return (_jsx(StatusMessage, { type: "warning", iconTitle: "exclamation circle icon", icon: FAS_CIRCLE_EXCLAMATION, messageTitle: translate('maximumMessageBox.title'), messageDescription: _jsxs(_Fragment, { children: [_jsx(Trans, __assign({ i18nKey: "addAnotherAuthorizedUser", value: onlineChatLink, components: { onlineChatLink: onlineChatLink } }, { children: translate('maximumMessageBox.addAnotherAuthorizedUser', {
                        onlineChatText: onlineChatText
                    }) })), "."] }) }));
};
export default MaximumMessageBox;
